import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IconButton, Select, MenuItem, InputLabel, FormControl, Checkbox, FormControlLabel } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { toast } from 'react-toastify';
import Grow from '@material-ui/core/Grow';
import API from "./../../../utils/api";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} />;
});

const initialFormState = {
  id: null,
  title: "",
  description: "",
  image: "",

}

const FormDialogAddCategory = (props) => {
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState(initialFormState);
  const [errors, setErrors] = useState({})
  const [selectedLang, setSelectedLang] = useState('en')

  const handleClickOpen = () => {
    setErrors({});
    setCategory(initialFormState);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleInputChange = event => {
    const { name, value, lang } = event.target

    if (lang) {
      setCategory({
        ...category,
        [name]: { ...category[name], [lang]: value }
      });

    } else {
      setCategory({ ...category, [name]: value })
    }
  }
  const handleInputChangeForFileType = event => {

    var formdata = new FormData();
    formdata.append("file", event.target.files[0]);
    formdata.append("documentId", Date.now());
    API.utility().upload(formdata)
      .then(res => {
        setCategory({ ...category, image: res.data.data.path })
      })

  }

  const validate = () => {
    let tempErrors = {};
    let formIsValid = true;

    if (!category.title) {
      formIsValid = false;
      tempErrors["title"] = "Cannot be empty";
    }

    if (!category.description ) {
      formIsValid = false;
      tempErrors["description"] = "Cannot be empty";
    }

    setErrors(tempErrors);
    return formIsValid;
  }

  const handleSubmit = (e) => {
    const onSuccess = () => {
      props.refresh()
      setOpen(false);
      toast.success('Data succesfully updated');
    }
    e.preventDefault();

    if (validate()) {
      props.create(category, onSuccess)
    }
  }

  return (
    <div>
      <IconButton color="primary" onClick={handleClickOpen} >
        <AddCircleIcon style={{ fontSize: "40px" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title" style={{ padding: "30px 30px 0px 30px" }}>Add category</DialogTitle>

        <DialogContent style={{ padding: "30px 30px 10px 30px" }}>


<Button variant="contained" component="label">
  Upload Icon
  <input
    type="file"
    name="file"
    label="Image"
    onChange={handleInputChangeForFileType}
    {...(errors.file && { error: true, helperText: errors.file })}
    hidden
  />
</Button>

<img src={process.env.REACT_APP_IMG_URL + category.image} height="100" style={{ marginTop: "-30px", float: "right" }} />

<div className="col-lg-12 col-12 mb-4">
<div className="row">
<div className="col-lg-12 col-12 mb-4">
<FormControl className="float-end">
<InputLabel id="demo-simple-select-label">Language</InputLabel>
<Select
value={selectedLang}
onChange={(e) => setSelectedLang(e.target.value)}
>
<MenuItem value="en">English</MenuItem>
<MenuItem value="ar">Arabic</MenuItem>
</Select>
</FormControl>
</div>


<div className="col-lg-12 col-12 mb-4">
<TextField

name="title"
label="Title"
value={category?.title[selectedLang]}
inputProps={{ 'lang': selectedLang }}
fullWidth
onChange={handleInputChange}
{...(errors.title && { error: true, helperText: errors.title })}
/>


</div>
<div className="col-lg-12 col-12 mb-4">

<TextField

name="description"
label="Description"
value={category?.description[selectedLang]}
inputProps={{ 'lang': selectedLang }}
fullWidth
onChange={handleInputChange}
multiline={true}
rows={3}
{...(errors.description && { error: true, helperText: errors.description })}
/>



</div>

</div>
</div>




</DialogContent>

        <DialogActions style={{ padding: 30 }}>
          <Button variant="contained" onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit} color="secondary">
            Save
          </Button>
        </DialogActions>

      </Dialog>
    </div>
  );
}

export default FormDialogAddCategory;